import type { User } from '../api.ts';
import { matchesStatus, type StatusFilterValue } from '../components/ListFilters.tsx';

/** Filtro de perfil "Sem perfil": quem não tem nenhuma atribuição. */
export const NO_ROLE = 'none';

export type UserFilters = {
  /** Trecho do nome ou do e-mail. */
  q: string;
  status: StatusFilterValue;
  /** Vazio: todos; `NO_ROLE`: sem perfil; senão, o id do perfil. */
  roleId: string;
};

export function matchesUser(u: User, f: UserFilters): boolean {
  const needle = f.q.trim().toLowerCase();
  return (
    matchesStatus(u.isActive, f.status) &&
    (!f.roleId ||
      (f.roleId === NO_ROLE
        ? u.assignments.length === 0
        : u.assignments.some((a) => a.roleId === f.roleId))) &&
    (!needle || [u.displayName, u.email].some((v) => v.toLowerCase().includes(needle)))
  );
}

/** Perfis do filtro: só os que alguém da lista tem, um por perfil, em ordem alfabética. */
export function roleOptions(
  users: User[],
  label: (name: User['assignments'][number]['roleName']) => string,
  language: string,
): { id: string; name: string }[] {
  const byId = new Map(users.flatMap((u) => u.assignments.map((a) => [a.roleId, a.roleName])));
  return [...byId]
    .map(([id, name]) => ({ id, name: label(name) }))
    .sort((a, b) => a.name.localeCompare(b.name, language));
}
